import React from 'react';
import PropTypes from 'prop-types';

import ContentSectionListCard from '../../../components/ContentSectionListCard';
import TextBannerSmall from '../../../components/TextBannerSmall';
import PriceBlock from '../../../components/PriceBlock';
import StickyButton from '../../../components/StickyButton';

import COMPONENT_TYPE from './componentType';

import './index.scss';

const ProductCheckoutPageComponentsMapper = {
  [COMPONENT_TYPE.contentSectionListCard]: ContentSectionListCard,
  [COMPONENT_TYPE.textBannerSmall]: TextBannerSmall,
  [COMPONENT_TYPE.priceBlock]: PriceBlock,
  [COMPONENT_TYPE.stickyButton]: StickyButton,
};

const ProductCheckoutPageGenerator = ({ data }) => {
  return (
    <>
      {data.items.map((item, key) => {
        const Component = ProductCheckoutPageComponentsMapper[item.type];

        const isFirstComponentTextBannerSmall =
          key === 0 && item.type === COMPONENT_TYPE.textBannerSmall;

        let className = `product-checkout-page-generator__${item.type}`;
        if (isFirstComponentTextBannerSmall) {
          className +=
            ' product-checkout-page-generator__textBannerSmall--first';
        }

        return (
          <div key={`${key}-${item.type}`} className={className}>
            <Component {...item.data} />
          </div>
        );
      })}
    </>
  );
};

ProductCheckoutPageGenerator.propTypes = {
  data: PropTypes.object,
};

export default ProductCheckoutPageGenerator;
